import type { ICategory } from "~/libs/types/api/category";
import type { BreadcrumbLink } from "#ui/types";

const getCategoryArray = (obj?: ICategory, path = ""): BreadcrumbLink[] => {
    if (!obj) return [];

    // Base case: if the object has no 'parent' key, return an array with this object
    if (!obj.parent) {
        return [
            {
                label: obj.name,
                to: `/category${path ? "/" + path + "/" + obj.slug : "/" + obj.slug}`,
                icon: obj.icon,
            },
        ];
    }

    // Recursive case: process parent first
    const parentArray: BreadcrumbLink[] = getCategoryArray(obj.parent, path + "/" + obj.slug);

    // Add current object to the beginning of the array
    const currentLink: BreadcrumbLink = {
        label: obj.name,
        to: `/category${path ? "/" + path + "/" + obj.slug : "/" + obj.slug}`,
        icon: obj.icon,
    };

    return [currentLink].concat(parentArray);
}

export default getCategoryArray;